import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './styles.module.scss';
import Button from '../../../Button/index.ts';
import Icon from '../../../Icon/index.ts';
import addVariants from '../../../utils/addVariants/index.ts';

export const ALIGN = ['top', 'center', 'bottom'];
export const VARIANTS = ['default', 'dense', 'comfortable', 'no-padding', 'active'];
const ICON_SIZES = ['xs', 'lg', 'sm', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x'];
const ListItemIcon = ({ align, variant: variants, href, onClick, className, ...props }) => {
  const iconEl = (
    <Icon
      className={classnames(addVariants('aglmd-list-item__icon', styles, variants), className)}
      {...props}
    />
  );

  if (onClick || href) {
    return (
      <div className={addVariants('aglmd-list-item__icon__container', styles, align)}>
        <Button onClick={onClick} href={href} color="transparent">
          {iconEl}
        </Button>
      </div>
    );
  }

  return (
    <div className={addVariants('aglmd-list-item__icon__container', styles, align)}>{iconEl}</div>
  );
};

ListItemIcon.propTypes = {
  align: PropTypes.oneOf(ALIGN),
  /**
   * Fired every time the list item is clicked
   */
  onClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  /**
   * Renders the list item as a link
   */
  href: PropTypes.string,
  /**
   * Decides the variant of the button
   */
  variant: PropTypes.oneOfType([
    PropTypes.oneOf(VARIANTS),
    PropTypes.bool,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf(VARIANTS), PropTypes.bool]))
  ]),
  /**
   * Specify which icon to use
   */
  icon: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string.isRequired),
    PropTypes.shape({
      iconName: PropTypes.string.isRequired,
      prefix: PropTypes.string.isRequired
    })
  ]),
  /**
   * Set the size of the icon
   */
  size: PropTypes.oneOf(ICON_SIZES),
  /**
   * Class to set on the icon
   */
  className: PropTypes.string,
  /**
   * Color of the icon
   */
  color: PropTypes.string
};

ListItemIcon.defaultProps = {
  align: 'center',
  className: '',
  variant: 'default',
  onClick: null,
  href: '',
  icon: [],
  size: '1x',
  color: ''
};

export default ListItemIcon;
